// extracted by mini-css-extract-plugin
export default {"popup_container":"square_popup_container__5d1uJ","popup_header":"square_popup_header__x1H36","popup_body":"square_popup_body__uHbG9"};